import { Prices, PricingPageContent } from '../../components/pages/pricingLegacy';
import Layout from '../../components/shared/Layout';
import { usePageVistTracker } from '../../hooks/usePageVistTracker';
import { getUpdatedPricingFeatureFlag } from '../../utils/analytics';

const DEFAULT_PRICES: Prices = {
  monthly: '$9.99',
  yearly: '$69.99',
};

const MODEST_PRICES: Prices = {
  monthly: '$12.99',
  yearly: '$89.99',
};

const Pricing: React.FC = () => {
  usePageVistTracker();

  const updatedPricingFeatureFlag = getUpdatedPricingFeatureFlag();
  const isModestIncrease = updatedPricingFeatureFlag === 'modest-increase';

  return (
    <Layout description="Plans and Pricing at BrainFM" pageTitle="Pricing">
      <PricingPageContent isLocalized={false} price={isModestIncrease ? MODEST_PRICES : DEFAULT_PRICES} />
    </Layout>
  );
};

export default Pricing;
